import { RoleDto } from '../../../api';
import Popup from '../../Popup';
import RoleQueries from '../../../pages/management/employees/roles/RoleQueries';
import RoleForm from '../../../pages/management/employees/roles/RoleForm';

interface ICreateRolePopupProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onSuccess?: (newRole: RoleDto) => void;
  roleNameSuggestion?: string;
}

function CreateRolePopup(props: ICreateRolePopupProps) {
  const { isOpen, setIsOpen, onSuccess, roleNameSuggestion = '' } = props;
  const { mutateCreateRole } = RoleQueries();

  return (
    <Popup openPopup={isOpen} setOpenPopup={setIsOpen} title="Create Role">
      <RoleForm
        onCancel={() => setIsOpen(false)}
        onSubmit={values => {
          mutateCreateRole(values, {
            onSuccess: newRole => {
              onSuccess && onSuccess(newRole);
              setIsOpen(false);
            },
          });
        }}
        roleNameSuggestion={roleNameSuggestion}
      />
    </Popup>
  );
}

export default CreateRolePopup;
